import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

interface StateProps {
  showAiTextPromptBoxDropdown: boolean;
  errorMessage: string | undefined;
  selectedTextComponentId: string;
}

const initialState: StateProps = {
  showAiTextPromptBoxDropdown: false,
  errorMessage: undefined,
  selectedTextComponentId: '',
};

export const emailMakerAiTextPromptBoxDropdownSlice = createSlice({
  name: 'emailMakerAiTextPromptBoxDropdown',
  initialState,
  reducers: {
    updateShowAiTextPromptBoxDropdown(state, action: PayloadAction<boolean>) {
      state.showAiTextPromptBoxDropdown = action.payload;
    },
    setErrorMessage(state, action: PayloadAction<string | undefined>) {
      state.errorMessage = action.payload;
    },
    recordSelectedTextComponentId(state, action: PayloadAction<string>) {
      state.selectedTextComponentId = action.payload;
    },
  },
});

export const {updateShowAiTextPromptBoxDropdown, setErrorMessage, recordSelectedTextComponentId} = emailMakerAiTextPromptBoxDropdownSlice.actions;
export const emailMakerAiTextPromptBoxDropdownReducer = emailMakerAiTextPromptBoxDropdownSlice.reducer;
